import { CollectorClient, createCollectorClient } from '@zoralabs/protocol-sdk';
import { usePublicClient } from 'wagmi';
import { TOKEN_SOURCE_CHAIN } from '../constants';

let collectorClient: CollectorClient | undefined;

export const useCollectorClient = () => {
  const publicClient = usePublicClient();
  collectorClient = publicClient && createCollectorClient({ chainId: TOKEN_SOURCE_CHAIN.id, publicClient });

  return { data: collectorClient };
};
